import Loop from '@mui/icons-material/Loop';
import { styled } from '@mui/material/styles';

export const RotatingLoopIcon = styled(Loop)({
  animation: 'spin 2s linear infinite',
});
